module.exports = __webpack_public_path__ + "static/img/sch-103.0ea2a71d.png";